module.exports = __webpack_public_path__ + "img/project14_6.jpg.f7c1b5f6.webp";